import { createContext } from 'react';

import { NOOP } from '../../constants';
import { ReturnUrlContextValue } from './types/ReturnUrlContextValue';

export const ReturnUrlContext = createContext<ReturnUrlContextValue>({
  returnUrl: '',
  returnUrlOwner: undefined,
  setReturnUrl: NOOP,
});
